import React, { useState } from "react";
import { STAGES, CHANNELS, stageOf } from "./leadConfig";

const fmtDate = (s) => (s ? new Date(s).toLocaleDateString() : "—");

export const LeadRow = ({ lead, source, onUpdate, onConvert }) => {
  const [note, setNote] = useState(lead.note || "");
  const stage = stageOf(lead.stage);
  const toggleChannel = (c) => {
    const set = new Set(lead.channels || []);
    set.has(c) ? set.delete(c) : set.add(c);
    onUpdate({ channels: [...set] });
  };

  return (
    <article data-testid={`lead-${lead.id}`} className="bg-white border border-[#c99658]/25 p-4 grid grid-cols-1 lg:grid-cols-[1.3fr_1fr_1.2fr] gap-4">
      <div className="min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <h5 className="font-cormorant text-xl leading-none text-[#0f2420]">{lead.name}</h5>
          <span className={`px-2 py-0.5 text-[10px] tracking-[0.15em] uppercase font-raleway ${stage.color}`}>{stage.label}</span>
        </div>
        <p className="text-[12px] text-neutral-600 mt-1 break-words">
          <a href={`mailto:${lead.email}`} className="hover:text-[#7a5b2f]">{lead.email}</a>
          {lead.phone && <> · <a href={`tel:${lead.phone}`} className="hover:text-[#7a5b2f]">{lead.phone}</a></>}
          {lead.company && <> · {lead.company}</>}
        </p>
        <p className="text-[11px] text-neutral-500 mt-1">
          Received {fmtDate(lead.created_at)}
          {lead.touched_at && <> · Last touched {fmtDate(lead.touched_at)}</>}
          {source === "catalog" && <> · Catalog: {lead.catalog || "windows"}</>}
          {lead.project_type && <> · {lead.project_type}</>}
        </p>
        {lead.message && <p className="text-[12px] text-neutral-700 mt-2 italic line-clamp-3">“{lead.message}”</p>}
        <div className="flex gap-3 mt-2 text-[10.5px] tracking-[0.2em] uppercase font-raleway">
          {(lead.plans_file_url || lead.plans_url) && (
            <a href={lead.plans_file_url || lead.plans_url} target="_blank" rel="noreferrer" className="text-[#7a5b2f] underline">Plans</a>
          )}
          {onConvert && <button data-testid={`convert-quote-${lead.id}`} onClick={onConvert} className="text-[#0f2420] hover:text-[#c99658]">→ Estimate</button>}
        </div>
      </div>

      <div>
        <label className="block text-[10px] tracking-[0.25em] uppercase font-raleway text-[#7a5b2f] mb-1">Stage</label>
        <select
          data-testid={`lead-stage-${lead.id}`}
          value={lead.stage || "new"}
          onChange={(e) => onUpdate({ stage: e.target.value })}
          className="w-full border border-neutral-300 bg-white px-2 py-2 text-sm"
        >
          {STAGES.map((s) => <option key={s.id} value={s.id}>{s.label}</option>)}
        </select>
        <label className="block text-[10px] tracking-[0.25em] uppercase font-raleway text-[#7a5b2f] mb-1 mt-3">How we connected</label>
        <div className="flex flex-wrap gap-1.5">
          {CHANNELS.map((c) => {
            const on = (lead.channels || []).includes(c.id);
            return (
              <button key={c.id} type="button" data-testid={`lead-channel-${c.id}-${lead.id}`} onClick={() => toggleChannel(c.id)}
                className={`px-2.5 h-7 text-[10px] tracking-[0.15em] uppercase font-raleway border transition-colors ${on ? "bg-[#0f2420] text-white border-[#0f2420]" : "border-neutral-300 text-neutral-600 hover:border-[#7a5b2f]"}`}>
                {c.label}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <label className="block text-[10px] tracking-[0.25em] uppercase font-raleway text-[#7a5b2f] mb-1">Notes</label>
        <textarea
          data-testid={`lead-note-${lead.id}`}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          onBlur={() => note !== (lead.note || "") && onUpdate({ note })}
          rows={4}
          placeholder="Called 6/18 — wants pivot door, follow up Monday…"
          className="w-full border border-neutral-300 bg-white px-3 py-2 text-sm"
        />
      </div>
    </article>
  );
};
